angular.module('rjmNg.directives').directive "dataWarehouseDatabaseList", [
  () ->
    restrict: "E"
    templateUrl: "directive.dataWarehouseDatabaseList.html"
    replace: true
    scope:
      showAllTables: '='
      rsDatabase: '='
      rsConnection: '='
      searchName: '='
      active: '='
      selectTableHandler: '='
      forceOpenTables: '='
    bindToController: true
    controllerAs: "view"
    controller: [
      "$rootScope"
      "$scope"
      "dataWarehouseTablePath"
      "remoteDBConnectionService"
      (
        $rootScope
        $scope
        dataWarehouseTablePath
        remoteDBConnectionService
      ) ->

        view = @

        view.generateTablePath = dataWarehouseTablePath.generateTablePath
        view.showTables = true

        view.rsTables = []

        $rootScope.$on('droppedTable', (event, connectionId, databaseName, schema, tableName) ->
          if view.rsDatabase.name == databaseName and view.rsConnection.id == connectionId
            tableToUpdate = _(view.rsTables).find (table) ->
              return table.name == tableName and table.schema == schema

            if tableToUpdate?
              tableToUpdate.trackedColor = 0
              remoteDBConnectionService.invalidateLocalTableCache(tableToUpdate.id)
              dataWarehouseTablePath.updateTablePath()
        )

        $rootScope.$on('addTable', (event, connectionId, databaseName, schema, tableName, tableId) ->
          if view.rsDatabase.name == databaseName and view.rsConnection.id == connectionId
            tableToUpdate = _(view.rsTables).find (table) ->
              return table.name == tableName and table.schema == schema
            if tableToUpdate?
              tableToUpdate.trackedColor = -1
              tableToUpdate.id = tableId
              dataWarehouseTablePath.updateTablePath(tableId)
              remoteDBConnectionService.addLocalTable(tableToUpdate)

        )

        # activeTables can be local tables or rsTables.
        _isTable = (activeTable, rsTable) ->
          activeTable.name is rsTable.name and
            activeTable.connectionId is rsTable.connectionId and
            activeTable.databaseName is rsTable.databaseName and
            activeTable.schema is rsTable.schema


        view.isTableSelected = (rsTable) ->
          unless view.active?.table? and rsTable?
            return false
          return _isTable(view.active.table, rsTable)

        view.databaseHasTables = () ->
          _.some view.rsTables, (table) ->
            table.trackedColor > 0 or table.trackedColor is -1

        view.selectTable = (clickEvent, connectionId, databaseName, rsTable) ->
          if view.isTableSelected(rsTable)
            clickEvent.preventDefault()
            return

          view.selectTableHandler(clickEvent, connectionId, databaseName, rsTable)

        view.transformDbName = (name) ->
          if name is 'userpush'
            return 'File Uploads'
          else
            return name

        view.openTables = () ->
          view.showTables = !view.showTables

        $scope.$watch 'forceOpenTables', () ->
          if view.forceOpenTables
            view.showTables = true

        @$onInit = ->
          angular.forEach(view.rsDatabase.rsSchemas, (schema) ->
            view.rsTables = view.rsTables.concat(
              _(schema.rsTables).map((value, key) ->
                return value
              )
            )
          )
        view
      ]
]
